import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectDeviceById } from "src/store/callrecorder/devicesSlice";
import { fetchDevice } from "src/actions/callrecorder/devicesActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import SidebarShow from "./_partials/_SidebarShow";
import Icon from "src/componets/Icon";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const record = useAppSelector(state => id ? selectDeviceById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchDevice(id));
    }
  }, [id, dispatch]);

  return (
    <PageLayout className='v-devices-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            record &&
              <SummaryShow
                icon={<Icon icon="fa-solid fa-mobile-screen" />}
                title={`Device #${id}`}
                subtitle={`${record.bundle} — ${record.vendor}`}
                createdAt={record.created_at}
                updatedAt={record.updated_at}
                className='v-mb-15'
              />
          }
        </div>
      </div>

      <SidebarShow record={record} />
    </PageLayout>
  )
}

export default Show;
